import React from "react"
import CMSRender from "aldoo-ra/CMS/cms-render"
import Typography from "aldoo-ra/Typography"
import PlatformsAvailable from "../Site/PlatformsAvailable"

const AppDownloadCTAPlatforms = ({ data }) => {
  return (
    <div className="flex flex-col">
      <CMSRender
        contentType="OxfordDictionary_CTA_Platforms"
        match={{ "content.name": "OxfordDictionary_CTA_article" }}
        renderItem={(data) => {
          return (
            <div>
              <Typography variant="body1_accent" className="mt-0 mb-1">
                {data.title}
              </Typography>

              <PlatformsAvailable variant="left" data={data} />
            </div>
          )
        }}
      />
    </div>
  )
}

export default AppDownloadCTAPlatforms
